import { render } from "./TemplateModal.vue?vue&type=template&id=3c489ccd&scoped=true"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"

import "./TemplateModal.vue?vue&type=style&index=0&id=3c489ccd&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c489ccd"]])

export default __exports__